export const BIZLAB_LATITUDE = 59.334135;
export const BIZLAB_LONGITUDE = 18.066333;